import { DialogDescription } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, PrinterCheck, X } from "lucide-react";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { noneProfile } from "assets";
import moment from "moment";
interface DialogProps {
  selectedYear: any;
  setOpenDrawer: any;
  attendanceSetting: any;
  loadingPrint: boolean;
  onUploadSuccess: ({ status }: { status: string }) => void;

  isDailogTimesheets: boolean;
  employeeLeaveDetail: any;
  loadingEmployeeLeaveDetail: any;
}
export default function PageDetailLeave({ loadingPrint, selectedYear, employeeLeaveDetail, onUploadSuccess, setOpenDrawer, loadingEmployeeLeaveDetail }: DialogProps) {
  type LeaveDetailItem = {
    id: number;
    entitlement_month: number;
    entitlement_year: number;
    no_of_day: string;
    entitlement_date: string;
    [key: string]: any; // for dynamic keys like jan_used_day
  };
  type GroupedData = {
    [monthIndex: string]: {
      monthName: string;
      items: LeaveDetailItem[];
    };
  };

  const groupEmployeeLeaveData = (data: LeaveDetailItem[]): GroupedData => {
    const groupedData: GroupedData = {};

    data.forEach((item) => {
      const monthIndex = moment(item.entitlement_date).month().toString(); // 0 to 11
      const monthName = moment(item.entitlement_date).format("MMMM");

      if (!groupedData[monthIndex]) {
        groupedData[monthIndex] = {
          monthName,
          items: [],
        };
      }
      groupedData[monthIndex]?.items.push(item);
    });
    return groupedData;
  };
  const groupedData = groupEmployeeLeaveData(employeeLeaveDetail || []);
  const allMonths = Array.from({ length: 12 }, (_, i) => ({
    monthIndex: i.toString(),
    monthName: moment().month(i).format("MMMM"),
  }));

  return (
    <>
      <div>
        <div className=" max-w-[1300px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <div>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col  absolute left-3 top-[12px]  ">
                <div className="font-bold">Leave Detail Report</div>
                <div>{selectedYear}</div>
              </div>
              {loadingPrint ? (
                <label
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all  duration-300 me-[50px] font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <Loader className="animate-spin" />
                </label>
              ) : (
                <label
                  onClick={() => {
                    onUploadSuccess({ status: "print" });
                  }}
                  htmlFor=""
                  className="hover:border-3  hidden hover:scale-110 transition-all absolute right-3 top-[12px]  duration-300 me-[50px] font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8  items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <PrinterCheck />
                </label>
              )}
            </div>
            <div
              className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 border border-gray-300 "
              onClick={() => {
                setOpenDrawer(null);
              }}
            >
              <X />
            </div>
          </div>
          <div className="flex justify-between pr-[20px]">
            {employeeLeaveDetail?.length > 0 && (
              <>
                <div className="flex flex-col items-start pt-3 ">
                  <p className="text-md font-semibold">{employeeLeaveDetail[0]?.local_name}</p>
                  <DialogDescription className="text-md">{employeeLeaveDetail[0]?.position}</DialogDescription>
                  <DialogDescription className="text-md">{employeeLeaveDetail[0]?.department}</DialogDescription>
                </div>
                <div className="overflow-hidden">
                  <ImageUrl className="rounded-md object-cover h-[100px]" src={!employeeLeaveDetail[0]?.picture ? noneProfile : employeeLeaveDetail[0]?.picture} alt="" />
                </div>
              </>
            )}
          </div>
          <ScrollArea className="mt-2 w-full gap-3  pr-[20px]">
            <div className="mt-2 gap-3 overflow-hidden overscroll-auto">
              {loadingEmployeeLeaveDetail ? (
                <SkeletonMusicLibrariesTable />
              ) : (
                <table className="w-full h-full border-b text-center rounded-md border-collapse">
                  <thead className="sticky z-50 top-0 left-0 text-[15px]  text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
                    <tr className="sticky left-0 top-0">
                      <th className="py-4 px-5  border text-start">Date</th>
                      <th className="py-4 px-5 text-right border whitespace-nowrap">NO. Of Day</th>
                    </tr>
                  </thead>

                  <tbody className="text-sm">
                    {allMonths.map(({ monthIndex, monthName }, index) => {
                      const group = groupedData[monthIndex];
                      const items = group?.items || [];
                      const validItems = items.filter((item) => moment(item.entitlement_date).isValid());

                      const monthKey = moment().month(parseInt(monthIndex)).format("MMM").toLowerCase();
                      const prevMonthKey = moment()
                        .month(parseInt(monthIndex) - 1)
                        .format("MMM")
                        .toLowerCase();
                      return (
                        <>
                          <tr className="font-bold text-start">
                            <td className="border px-5 py-2">{monthName}</td>
                            <td className="border px-5 py-2 text-right">
                              {(() => {
                                if (index === 0) {
                                  // January shows dec_end_day or "-"
                                  const val = parseFloat(employeeLeaveDetail?.[0]?.total_no_of_day);
                                  return !isNaN(val) ? <p className=" font-bold">{val}</p> : "-";
                                } else {
                                  const endDay = employeeLeaveDetail?.[0]?.[`${prevMonthKey}_end_day`];
                                  return endDay && endDay !== "0.000" ? <p className="font-bold">{parseFloat(endDay).toString()}</p> : "-";
                                }
                              })()}
                            </td>
                          </tr>

                          {validItems.length > 0 ? (
                            validItems.map((item, i) => {
                              const formattedDate = moment(item.entitlement_date).format("ddd, D-MMM-YYYY");
                              const noOfDay = parseFloat(item.no_of_day);
                              return (
                                <tr key={i} className="text-start">
                                  <td className="border px-5 py-2">{formattedDate}</td>
                                  <td className="border px-5 py-2 text-right">{!isNaN(noOfDay) ? noOfDay.toString() : "-"}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="border px-5 py-2 italic text-gray-400" colSpan={2}>
                                No data
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })}

                    <tr className="font-bold">
                      <td className="border px-5 py-2 text-left">Total</td>
                      <td className="border px-5 py-2 text-right">
                        {(() => {
                          const endDay = employeeLeaveDetail?.[0]?.[`dec_end_day`];
                          return endDay && endDay !== "0.000" ? <p className="font-bold">{parseFloat(endDay).toString()}</p> : "-";
                        })()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <ScrollBar orientation="vertical" />
          </ScrollArea>
          <ScrollBar orientation="vertical" />
        </div>
      </div>
    </>
  );
}
